export default __webpack_public_path__ + "static/media/caloriechef.ff2dfe38.png";